export enum EInputFieldType {
  STRING = 'string',
  FILE = 'file',
  FILES = 'files',
  IMAGE = 'image',
}

